import { mapGetters, mapActions } from "vuex";
import { types as VI } from "@/store/vi";
import couponItem from "@/components/couponItem.vue";

import { uleUrl } from "@/libs/common";
import { userCoupon } from "@/libs/api.js";
import countDown from "../components/countDown.vue";
const getters = mapGetters({
  getViStorage: VI.VI_STORAGE,
});
const actions = mapActions({
  setViStorage: VI.VI_STORAGE,
});

export default {
  name: "userCoupon",
  components: { couponItem, countDown },
  data() {
    return {
      tabHeight: 0,
      tabActive: 0,
      unusedCouponArr: [
        // {
        //   activeDate: "2023-08-09",
        //   activeFullDate: "2023-08-09 00:00:00",
        //   activeUrl: "",
        //   amount: "5",
        //   batchId: "724015",
        //   businessType: "1",
        //   categoryId: null,
        //   code: "9QCFLVVL",
        //   couponColour: "#f4730d",
        //   couponId: null,
        //   couponName: "商品券",
        //   couponType: "2",
        //   couponUrl: "",
        //   createTime: null,
        //   cssName: "commodity",
        //   currentTime: "2023-08-14 16:11:30",
        //   desc: "满10.0可用",
        //   expiredDate: "2023-08-31",
        //   expiredFullDate: "2023-08-14 16:57:00",
        //   flag: "1",
        //   forthcomingCoupon: "0",
        //   id: null,
        //   isMobile: null,
        //   isMultiStore: "false",
        //   isTodayCoupon: "1",
        //   listId: "3638625,3638626,3638629",
        //   listName: null,
        //   multiCategory: null,
        //   orderId: null,
        //   prdCount: 2,
        //   remark: "限上海王者荣耀邮政有限指定商品,满10.0元使用",
        //   salesChannelLimit: "all",
        //   showTitle: "商品券",
        //   status: "1",
        //   storeCount: 0,
        //   storeId: null,
        //   storeName: null,
        //   typeId: null,
        //   usedTime: null,
        //   usedUserId: null,
        //   userId: null,
        // },
        // {
        //   activeDate: "2023-08-09",
        //   activeFullDate: "2023-08-09 00:00:00",
        //   activeUrl: "",
        //   amount: "5",
        //   batchId: "724015",
        //   businessType: "1",
        //   categoryId: null,
        //   code: "9QCFLVVL2",
        //   couponColour: "#f4730d",
        //   couponId: null,
        //   couponName: "商品券",
        //   couponType: "2",
        //   couponUrl: "",
        //   createTime: null,
        //   cssName: "commodity",
        //   currentTime: "2023-08-14 16:11:30",
        //   desc: "满10.0可用",
        //   expiredDate: "2023-08-31",
        //   expiredFullDate: "2023-08-14 16:57:00",
        //   flag: "1",
        //   forthcomingCoupon: "0",
        //   id: null,
        //   isMobile: null,
        //   isMultiStore: "false",
        //   isTodayCoupon: "1",
        //   listId: "3638625,3638626,3638629",
        //   listName: null,
        //   multiCategory: null,
        //   orderId: null,
        //   prdCount: 2,
        //   remark: "限上海王者荣耀邮政有限指定商品,满10.0元使用",
        //   salesChannelLimit: "all",
        //   showTitle: "商品券",
        //   status: "1",
        //   storeCount: 0,
        //   storeId: null,
        //   storeName: null,
        //   typeId: null,
        //   usedTime: null,
        //   usedUserId: null,
        //   userId: null,
        // },
        // {
        //   activeDate: "2023-08-09",
        //   activeFullDate: "2023-08-09 00:00:00",
        //   activeUrl: "",
        //   amount: "5",
        //   batchId: "724015",
        //   businessType: "1",
        //   categoryId: null,
        //   code: "9QCFLVVL3",
        //   couponColour: "#f4730d",
        //   couponId: null,
        //   couponName: "商品券",
        //   couponType: "2",
        //   couponUrl: "",
        //   createTime: null,
        //   cssName: "commodity",
        //   currentTime: "2023-08-14 16:11:30",
        //   desc: "满10.0可用",
        //   expiredDate: "2023-08-31",
        //   expiredFullDate: "2023-08-20 16:39:00",
        //   flag: "1",
        //   forthcomingCoupon: "0",
        //   id: null,
        //   isMobile: null,
        //   isMultiStore: "false",
        //   isTodayCoupon: "1",
        //   listId: "3638625,3638626,3638629",
        //   listName: null,
        //   multiCategory: null,
        //   orderId: null,
        //   prdCount: 2,
        //   remark: "限上海王者荣耀邮政有限指定商品,满10.0元使用",
        //   salesChannelLimit: "all",
        //   showTitle: "商品券",
        //   status: "1",
        //   storeCount: 0,
        //   storeId: null,
        //   storeName: null,
        //   typeId: null,
        //   usedTime: null,
        //   usedUserId: null,
        //   userId: null,
        // },
      ], //未使用优惠券
      usedCouponArr: [], //已使用优惠券
      datedCouponArr: [], //已过期优惠券
      finished: false,
      loading: false,
      pageNum: 1,
    };
  },
  computed: {
    ...getters,
    couponArr() {
      //计算渲染优惠券列表
      let coupon = [];
      switch (this.tabActive) {
        case 0:
          coupon = this.unusedCouponArr;
          break;
        case 1:
          coupon = this.usedCouponArr;
          break;
        case 2:
          coupon = this.datedCouponArr;
          break;
        default:
          coupon = this.unusedCouponArr;
      }
      console.log(coupon,'couppppp');
      return coupon;
    },
  },
  methods: {
    ...actions,
    userCoupon(item) {
      // 优鲜优惠券
      if(item.businessType == 4){
        //去使用优惠券
        if (item.salesChannelLimit == "104") {
          //限制邮乐app使用
          window.location.href = `https://h5.${uleUrl()}/hd/zone/uleapp/index.html`;
        } else {
          //去使用优惠券
          if (item.activeUrl) {
            window.location.href = item.activeUrl;
          } else this.toNext("/category/categoryList");
        }
      }
      // 大网优惠券
      else if(item.businessType == 1){
        if(item.couponUrl){
          window.location.href = item.couponUrl;
        }
      }
    },
    changeTab(name) {
      // 切换优惠券tab
      this.tabActive = name;
      this.initCoupon();
      this.getUserCoupon();
    },
    initCoupon() {
      //初始化券相关请求和渲染参数
      this.pageNum = 1;
      this.finished = false;
      this.loading = false;
      this.unusedCouponArr = [];
      this.usedCouponArr = [];
      this.datedCouponArr = [];
    },
    getUserCoupon() {
      // 获取优惠券列表
      let data = {
        status: this.tabActive + 1, //1可使用,2已使用,3已过期,
        pageSize: 10,
        pageIndex: this.pageNum,
        businessType: 4,
        clientCallType: "H5",
      };
      // 试点
      console.log('this.$cookies.get("ispioltCity")',this.$cookies.get("ispioltCity"))
      if(this.$cookies.get("ispioltCity")){
        if(this.$cookies.get("selectSite")){
          console.log('123',this.$cookies.get("selectSite"))
          let selectSite = this.$cookies.get("selectSite");
          console.log(selectSite,'selectSite')
          if(selectSite.adcode){
            data.areaCode = selectSite.adcode;
            data.cityCode = String(selectSite.adcode).slice(0, 4) + '00';
            data.provinceCode = String(selectSite.adcode).slice(0, 2) + '0000';
          }
        }
      }
      this.unusedCouponArr.forEach((item) => {
        console.log(item);
        item.hours = this.$moment(item.expiredFullDate).diff(this.$moment(), "hours");
        item.lastTime = this.$moment(item.expiredFullDate)
          .diff(this.$moment())
          .toString();
        item.isOver = false;
      });
      userCoupon(data, "jsoncallback").then((res) => {
        console.log(res);
        if ((res.returnCode === "0000" || res.code === "0000") && res.data.couponInfo) {
          switch (data.status) {
            case 1:
              this.unusedCouponArr = [...this.unusedCouponArr, ...res.data.couponInfo];
              this.unusedCouponArr.forEach((item) => {
                console.log(item);
                if(item.couponBatchOrgName){
                  item.couponAreaName = item.couponBatchOrgName.split(',')[0];
                }
                item.hours = this.$moment(item.expiredFullDate).diff(this.$moment(), "hours");
                item.lastTime = this.$moment(item.expiredFullDate)
                  .diff(this.$moment())
                  .toString();
              });
              break;
            case 2:
              this.usedCouponArr = [...this.usedCouponArr, ...res.data.couponInfo];
              break;
            case 3:
              this.datedCouponArr = [...this.datedCouponArr, ...res.data.couponInfo];
              break;
            default:
              this.unusedCouponArr = [...this.unusedCouponArr, ...res.data.couponInfo];
              this.unusedCouponArr.forEach((item) => {
                console.log(item);
                item.hours = this.$moment(item.expiredFullDate).diff(this.$moment(), "hours");
                item.lastTime = this.$moment(item.expiredFullDate)
                  .diff(this.$moment())
                  .toString();
              });
          }
          let totalCoupon = res.data.couponTotal || 0;
          if (totalCoupon <= this.pageNum * 10) {
            this.finished = true;
            this.loading = false;
          } else {
            this.pageNum++;
            this.finished = false;
            this.loading = false;
          }
        } else {
          this.$toast(res.returnMessage);
          this.loading = false;
          this.finished = true;
        }
      });
    },
    resizeEvent() {
      this.tabHeight = this.$el.querySelector(".van-nav-bar").clientHeight;
    },
    coupoPageBack() {
      this.$router.go(-1);
    },
    // 更新接龙状态
    getStateCanOver(index) {
      // this.unusedCouponArr = [];
      // this.initCoupon();
      // this.getUserCoupon();
      // console.log("倒计时");
      this.couponArr[index].status = 3;
      console.log("thi", this.couponArr);
    },
    downChange(e) {
      if (e.hours < 10) {
        e.hours = `0${e.hours}`;
      }
      if (e.minutes < 10) {
        e.minutes = `0${e.minutes}`;
      }
      if (e.seconds < 10) {
        e.seconds = `0${e.seconds}`;
      }
    },
    activelFinish(e) {
      console.log("e", e);

      // this.unusedCouponArr[e].isOver = true;
      // this.$set(this.unusedCouponArr[e], "isOver", true);
      // console.log(this.unusedCouponArr,'unusedCouponArr');
    },
  },
  created() {
    window.addEventListener("resize", this.resizeEvent, true);
    this.getUserCoupon();
  },
  mounted() {
    this.resizeEvent();
    // 优鲜app
    if (this.$browser().ylxdsq) {
      // 小店去掉原生头
      window.dsBridge &&
        window.dsBridge.call("setNativeTitle", {
          title: "",
        });
    }
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("resize", this.resizeEvent);
    });
  },
};
